import React from "react";
import Typography from "@material-ui/core/Typography";
import { ManualDataStatus } from "../../helper/constants";

const RenderDataStatusMessage = ({ status, ...props }) => {
  if (props.disabled) {
    return <></>;
  }

  let message = null;

  switch (status) {
    case ManualDataStatus.Processing:
      message = "Uploaded data is being processed ...";
      break;
    case ManualDataStatus.Finished:
      message = "Uploaded data is successfully processed";
      break;
    case ManualDataStatus.FinishedWithErrors:
      message = (
        <p style={{ color: "red" }}>
          There was an error processing the uploaded data. Please upload the
          data again.
        </p>
      );
      break;
    default:
      message = "";
      break;
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ margin: "auto" }}>
        {message && <Typography variant="body1">{message}</Typography>}
      </div>
    </div>
  );
};

export default RenderDataStatusMessage;
